export const API_URL = 'https://halaltravel.zurich.weplus.id/api'
export const GA_TRACKING_ID = 'UA-116129655-3'
